import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material';
import React, { FC, useCallback, useEffect } from 'react';
import { HistoryFilter, HistoryInterface, Order } from '../../interfaces';
import HistoryTableHead from './HistoryTableHead';
import HistoryTableRow from './HistoryTableRow';

interface HistoryTableInterface {
	data: HistoryInterface[];
	filter: HistoryFilter;
	onFilterChange: (value: HistoryFilter | object) => void;
	hidden: boolean;
}

const HistoryTable: FC<HistoryTableInterface> = ({
	data,
	onFilterChange,
	filter,
	...props
}) => {
	const [order, setOrder] = React.useState<Order>(filter.order || Order.ASC);
	const [orderBy, setOrderBy] = React.useState<string | undefined>(filter.orderBy);

	const handleRequestSort = useCallback(
		(event: React.MouseEvent<unknown>, property: string | undefined) => {
			const isAsc = orderBy === property && order === Order.ASC;
			setOrder(isAsc ? Order.DESC : Order.ASC);
			setOrderBy(property);
		},
		[order, orderBy, setOrder, setOrderBy]
	);

	useEffect(() => {
		onFilterChange({ order, orderBy });
	}, [order, orderBy]);

	return (
		<>
			<TableContainer component={Paper} {...props}>
				<Table sx={{ minWidth: 650 }} aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell></TableCell>
							<HistoryTableHead
								title="ID"
								order={order}
								columnName="id"
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<HistoryTableHead
								title="User ID"
								order={order}
								columnName="user_id"
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<HistoryTableHead
								title="Student ID"
								order={order}
								columnName="student_id"
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<HistoryTableHead
								title="Request ID"
								order={order}
								columnName="request_id"
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<HistoryTableHead
								title="Reason"
								order={order}
								columnName="notes"
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<HistoryTableHead
								title="Date / Time"
								order={order}
								columnName="dateTime"
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
						</TableRow>
					</TableHead>
					<TableBody>
						{data.map((row, index) => (
							<HistoryTableRow key={'history_row'+index} row={row} />
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default HistoryTable;
